// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"a986cab3","942":"00089189"}[chunkId] + ".chunk.css";
};